import { render, staticRenderFns } from "./MultiList.vue?vue&type=template&id=baa5da66&"
import script from "./MultiList.vue?vue&type=script&lang=js&"
export * from "./MultiList.vue?vue&type=script&lang=js&"
import style0 from "./MultiList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports